import { ClickEventComponentNames } from 'features/analytics';
import { logButtonClick } from 'features/navigation/utils/analytics';

export const sendHeroClickEvent = ({
  imageLink,
  daypart,
}: {
  imageLink: string;
  daypart?: string | null;
}) => {
  logButtonClick({
    attributes: {
      component: ClickEventComponentNames.BUTTON,
      name: 'Homepage Hero image',
      url: imageLink ?? '',
      daypart: daypart ?? '',
    },
  });
};
